import { IMapState } from '../types';

export function selectIsAwaitingGeoFocus(state: IMapState): boolean {
  return state.map.isAwaitingGeoFocus;
}
